import { css } from 'styled-components';
var styles = css(["color:var(--sc-field-error--color,", ");position:absolute;margin-top:var(--sc-spacing-4,15px);"], function (props) {
  var _props$theme, _props$theme$fieldErr;
  return (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$fieldErr = _props$theme.fieldError) === null || _props$theme$fieldErr === void 0 ? void 0 : _props$theme$fieldErr.errorColor;
});
export default styles;